import {
    StyleSheet
} from "react-native";
import {
    webStyle
} from "ncore-ui-kit";

const stylesheet = StyleSheet.create({
    container: {
        position: "absolute",
        maxWidth: "92%",
        zIndex: 9999,
        bottom: 24,
        width: 380,
        right: 24,
        ...webStyle({
            boxShadow: "0 8px 32px rgba(0, 0, 0, 0.16)",
            position: "fixed"
        })
    },
    headerContainer: {
        justifyContent: "space-between",
        flexDirection: "row",
        alignItems: "center"
    },
    itemContainer: {
        justifyContent: "space-between",
        flexDirection: "row",
        alignItems: "center"
    },
    itemStatusContainer: {
        justifyContent: "center",
        alignItems: "center"
    },
    itemInfoContainer: {
        flexDirection: "row",
        alignItems: "center",
        flex: 1
    },
    actionsContainer: {
        flexDirection: "row",
        alignItems: "center"
    },
    titleContainer: {
        flexDirection: "row",
        alignItems: "center",
        flex: 1
    },
    progressBarContainer: {
        overflow: "hidden",
        width: "100%",
        height: 4
    },
    itemTitleContainer: {
        flex: 1
    },
    contentContainer: {
        maxHeight: 280
    },
    progressBarFill: {
        height: "100%"
    }
});
export default stylesheet;
